module.exports = __webpack_public_path__ + "img/safetyImg1.4f04a61e.png";